module.exports = __webpack_public_path__ + "static/media/poster-920.ea78ae68.webp";